module.exports = __webpack_public_path__ + "img/官方微信.7fbf84ac.png";